interface IProps {
  text: string;
}

export const ErrorMessage = (props: IProps) => {
  return <p style={{ color: "red", textAlign: "center", fontSize: "0.8rem" }}>{props.text}</p>;
};
